import { useMemo } from 'react'
import statesJSON from '../utils/states.json'

export const abbrToName = abbr => statesJSON[abbr.toLowerCase()]

export const nameToAbbr = name => {
    const entry = Object.entries(statesJSON).find(([, v]) => v === name?.toLowerCase())
    return entry?.[0]?.toUpperCase()
}

export function useStates(templates = []) {
    const stateOptions = useMemo(() => {
        const seen = new Set()
        return templates
            .flatMap(t => t.states ?? [])
            .reduce((acc, s) => {
                const abbr = nameToAbbr(s.name)
                if (!abbr || seen.has(abbr)) return acc
                seen.add(abbr)
                acc.push(abbr)
                return acc
            }, [])
            .sort()
    }, [templates])

    return { stateOptions }
}
